import React from 'react';
import { colors, Div } from 'globalStyle';
import {
  colorByProjectType, projectTypes, typesProjectType, isAEquityOrTokenProject,

} from 'types/projectType';
import { useMediaQuery } from 'hooks';
import { Box, Grid } from '@material-ui/core';
import { getContrastTextColor } from 'util/contrast';
import { ReactComponent as ProjectPay } from 'assets/icons/project-pay-current-color.svg';
import { ReactComponent as ImgProjectType } from 'assets/icons/project-type-money-current-color.svg';
import { routes } from 'routes';
import { Title, Text } from 'components/Texts';
import StyledHollow from 'components/Cards/components/StyledHollow';

export default function AboutProjectType({ projectType, id, color }) {
  const isDesktop = useMediaQuery(1023);
  return (
    <>
      {isDesktop && (
        <Div
          padding="25px 50px"
          margin="50px 0 0"
          isFlex
          justify="space-between"
          style={{
            backgroundColor: color || colorByProjectType[projectType],
            color: getContrastTextColor(color || colorByProjectType[projectType]),
          }}
        >
          <Div
            isFlex
            margin="0 40px 0 0"
            width="calc(50% - 40px)"
            style={{
              borderRight: `1px solid ${getContrastTextColor(color || colorByProjectType[projectType])}`,
            }}
          >
            <Box
              width="46px"
              height="31px"
              marginRight="36px"
            >
              <ImgProjectType
                color={getContrastTextColor(color || colorByProjectType[projectType])}
              />
            </Box>
            <Grid
              container
              direction="column"
              style={{
                width: 'fit-content',
              }}
            >
              <Text size={14} color="inherit">
                Tipo de proyecto
              </Text>
              <Title size={20} color="inherit" mb={10}>
                {`${typesProjectType[projectType]}`}
              </Title>
              <Text size={14} color="inherit">
                Tipo de Valor
              </Text>
              <Title size={20} color="inherit">
                Bonos de Deuda
              </Title>
            </Grid>
          </Div>
          <Div isFlex justify="space-between" width="50%">
            <Box width="36px">
              <ProjectPay color={getContrastTextColor(color || colorByProjectType[projectType])} />
            </Box>
            {isAEquityOrTokenProject(projectType) && (
              <>
                <Title color="inherit" size={20} style={{ maxWidth: '272px' }}>
                  Conoce más sobre las condiciones del proyecto
                </Title>
                <StyledHollow
                  size={14}
                  customColor={colors.WHITE}
                  hoverColorText={colorByProjectType[projectType]}
                  style={{ width: '220px', height: '45px', padding: '13px 0' }}
                  href={`${routes.conditionsAndCharacteristics.route}/${projectType.toLowerCase()}/${id}`}
                  textColor={getContrastTextColor(
                    color || colorByProjectType[projectType],
                    { defaultDark: color || colorByProjectType[projectType] },
                  )}
                >
                  Ver condiciones
                </StyledHollow>
              </>
            )}
            {projectType === projectTypes.LOAN && (
              <Title color="inherit" width="calc(100% - 64px - 6.84%)" size={13}>
                Este proyecto permite el pre&#8209;pago total o parcial de la
                deuda
                <br />
                <br />
                Este proyecto no acepta recursos que superen su monto objetivo.
              </Title>
            )}
            {projectType === projectTypes.STOCKS && (
              <Title color="inherit" width="calc(100% - 64px - 6.84%)">
                Este proyecto puede o no pagar Dividendos
              </Title>
            )}
          </Div>
        </Div>
      )}
    </>
  );
}
